import React from 'react';
import { WarningOutlined } from "@ant-design/icons";

// util error handling is not designed, redirect all errors here for the time being

export function ErrorSink({message}) {

  if (!message) {
    return null;
  }

  return <div>
    <WarningOutlined style={{color: '#FF9900'}}/>
    {message}
  </div>

}

export function errorSink(message, key) {
  return <ErrorSink key={key} message={message} />
}